module.exports = __webpack_public_path__ + "static/media/thomLukeSales.9dc5076b.jpg";